import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './AimTrainer.css';

const AimTrainer = () => {
  const [targets, setTargets] = useState([]);
  const [score, setScore] = useState(0);
  const [timeLeft, setTimeLeft] = useState(30);
  const [gameActive, setGameActive] = useState(false);
  const [gameOver, setGameOver] = useState(false);
  const timerRef = useRef(null);

  const GAME_WIDTH = 500;
  const GAME_HEIGHT = 500;
  const TARGET_SIZE = 40;

  const createTarget = () => ({
    x: Math.random() * (GAME_WIDTH - TARGET_SIZE),
    y: Math.random() * (GAME_HEIGHT - TARGET_SIZE),
    id: Date.now() + Math.random()
  });

  const startGame = () => {
    setGameActive(true);
    setGameOver(false);
    setScore(0);
    setTimeLeft(30);
    setTargets([createTarget()]);
  };

  const handleTargetClick = (targetId) => {
    setTargets(t => t.filter(target => target.id !== targetId));
    setScore(s => s + 1);
    setTargets(t => [...t, createTarget()]);
  };

  useEffect(() => {
    if (!gameActive || gameOver) return;

    timerRef.current = setInterval(() => {
      setTimeLeft(t => {
        if (t <= 1) {
          setGameActive(false);
          setGameOver(true);
          return 0;
        }
        return t - 1;
      });
    }, 1000);

    return () => clearInterval(timerRef.current);
  }, [gameActive, gameOver]);

  return (
    <div className="game-container">
      <div className="game-header">
        <h1 className="game-title-header">🎯 Aim Trainer</h1>
        <div className="game-instructions">
          Click the targets as fast as you can!
        </div>
      </div>

      <div className="game-board">
        <div className="score-display">
          Score: {score} | Time: {timeLeft}s
        </div>
        
        <div className="game-play-area">
          <div className="aim-game-area">
            {targets.map(target => (
              <div
                key={target.id}
                className="target"
                style={{ left: target.x, top: target.y }}
                onClick={() => handleTargetClick(target.id)}
              >
                🎯
              </div>
            ))}

            {!gameActive && (
              <div className="game-status-overlay">
                {gameOver ? (
                  <div className="status-message">Final Score: {score}</div>
                ) : (
                  <div className="status-message start">Click Start!</div>
                )}
              </div>
            )}
          </div>
        </div>

        <div className="game-controls">
          <button className="btn btn-primary" onClick={startGame}>
            {gameOver ? 'Play Again' : 'Start Game'}
          </button>
          <Link to="/" className="btn btn-secondary">Back to Home</Link>
        </div>
      </div>
    </div>
  );
};

export default AimTrainer;
